import { subscribeRNMessage } from './fromRN'
import { postMessageToRN } from './toRN'
import { messageInfo } from '@/utils/messageLog'
import type { H5ToRNMessage, NativeCachedAudio } from './types'

let sequence = 0
type CacheParams = Extract<H5ToRNMessage, { type: 'audioCache' }>['params']
interface CachedFile { relativePath?: string; sizeBytes?: number; durationMs?: number }

/** 按 requestId 配对，重复回调与旧会话响应不会完成其他请求。 */
function request(params: CacheParams): Promise<CachedFile | null> {
  if (!window.ReactNativeWebView) return Promise.resolve(null)
  return new Promise(resolve => {
    const finish = (data: CachedFile | null) => {
      clearTimeout(timer)
      unsubscribe()
      resolve(data)
    }
    const unsubscribe = subscribeRNMessage('audioCacheResult', event => {
      if (event.requestId !== params.requestId) return
      if (params.action === 'prepare') messageInfo('音频缓存准备响应', { requestId: params.requestId, messageId: params.messageId, success: event.success, error: event.error, durationMs: event.data?.durationMs })
      finish(event.success && event.data ? event.data : null)
    })
    const timer = setTimeout(() => {
      messageInfo('音频缓存请求超时', { requestId: params.requestId, action: params.action })
      finish(null)
    }, 75_000)
    try {
      if (params.action === 'prepare') messageInfo('请求准备音频缓存', { requestId: params.requestId, userId: params.userId, subUserId: params.subUserId, messageId: params.messageId })
      postMessageToRN({ type: 'audioCache', params })
    } catch (error) {
      messageInfo('音频缓存桥接请求失败', { requestId: params.requestId, error })
      finish(null)
    }
  })
}

export function downloadAudioViaRN(params: NativeCachedAudio): Promise<CachedFile | null> {
  return request({ ...params, action: 'prepare', requestId: `audio-cache-${Date.now()}-${++sequence}` })
}

export async function pruneAudioCacheViaRN(scope: { userId: string; subUserId: number }): Promise<void> {
  await request({ ...scope, action: 'prune', requestId: `audio-prune-${Date.now()}-${++sequence}` })
}
